import React, { useState } from 'react';
import RootLayout from '../component/Layout';
import styles from './support.module.scss';
import styles_mobile from './support_mobile.module.scss';
import TopLogo from '../component/TopLogo';
import Img from '../component/Img';
import useScreenWidthBelowThreshold from '../hooks/useScreenWidthBelowThreshold';

export default () => {
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [details, setDetails] = useState('');
  const [isSend, setIsSend] = useState(false);
  const [namePlaceholder, setNamePlaceholder] = useState('Name*');
  const [emailPlaceholder, setEmailPlaceholder] = useState('E-Mail*');
  const [detailsPlaceholder, setDetailsPlaceholder] = useState('Details of Inquiry*');

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmit = () => {
    let validationPassed = true;
    if (name.trim() === '') {
      setNamePlaceholder('Please fill in your name');
      validationPassed = false;
    }
    if (details.trim() === '') {
      setDetailsPlaceholder('Please fill in your inquiry');
      validationPassed = false;
    }
    if (!validateEmail(email)) {
      setEmailPlaceholder('Please fill in your email address correctly');
      setEmail('');
      validationPassed = false;
    } else if (email.trim() === '') {
      setEmailPlaceholder('Please fill in your email address');
      validationPassed = false;
    }
    if (validationPassed) {
      const data = {
        text: JSON.stringify({ name, company, email, details }),
      };
      fetch('/api/mail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.status === 'ok') {
            setIsSend(true);
          } else {
            console.log('Error sending email.');
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  };

  if (isScreenWidthBelow700px) {
    return (
      <RootLayout className={styles_mobile.wrapper}>
        <TopLogo />
        <div className={styles_mobile.card}>
          <div className={styles_mobile.content}>
            <div className={styles_mobile.mail}>
              For User Services:
              <div>
                <a href="mailto:support@duetapp.net?subject=Duet Feedback Submission&body=Dear Duet Team,%0D%0A%0D%0AI am writing to provide feedback on an issue I encountered. Here are the details:%0D%0A%0D%0APhone number:%0D%0AOperating System (OS):%0D%0ADescription of the Issue:%0D%0A%0D%0AFor further clarity, I have attached evidence (either a screenshot or screen recording) related to the issue.%0D%0A%0D%0ALooking forward to your prompt response and resolution.%0D%0A%0D%0A%0D%0ABest Regards,%0D%0A%0D%0A[Your Name]">
                  {' '}
                  support@duetapp.net
                </a>
              </div>
            </div>
            <div className={styles_mobile.mail}>
              For Collaborations/Media:
              <div>
                <a href="mailto:pr@duetapp.net?subject=Duet Collaboration/Media Inquiry&body=Thank you for your interest in Duet! If you are considering collaboration or seeking data/ information/quotes with Duet, please kindly provide the following details:%0D%0A%0D%0A%20%20%20%201. Name:%0D%0A%0D%0A%20%20%20%202. Organization:%0D%0A%0D%0A%20%20%20%203. Contact Info:%0D%0A%0D%0A%20%20%20%204. Purpose:%0D%0A%0D%0AUpon receipt of these details, we will respond to you promptly.%0D%0A%0D%0ABest Regards,%0D%0A%0D%0ADuet Team">
                  {' '}
                  pr@duetapp.net
                </a>
              </div>
            </div>
          </div>
        </div>
      </RootLayout>
    );
  } else {
    return (
      <RootLayout className={styles.wrapper}>
        <TopLogo />
        <div className={styles.card}>
          <div className={styles.content}>
            <div className={styles.mail}>
              For User Services:
              <a href="mailto:support@duetapp.net?subject=Duet Feedback Submission&body=Dear Duet Team,%0D%0A%0D%0AI am writing to provide feedback on an issue I encountered. Here are the details:%0D%0A%0D%0APhone number:%0D%0AOperating System (OS):%0D%0ADescription of the Issue:%0D%0A%0D%0AFor further clarity, I have attached evidence (either a screenshot or screen recording) related to the issue.%0D%0A%0D%0ALooking forward to your prompt response and resolution.%0D%0A%0D%0A%0D%0ABest Regards,%0D%0A%0D%0A[Your Name]">
                {' '}
                support@duetapp.net
              </a>
            </div>
            <div className={styles.mail}>
              For Collaborations/Media:
              <a href="mailto:pr@duetapp.net?subject=Duet Collaboration/Media Inquiry&body=Thank you for your interest in Duet! If you are considering collaboration or seeking data/information/quotes with Duet, please kindly provide the following details:%0D%0A%0D%0A%20%20%20%201. Name:%0D%0A%0D%0A%20%20%20%202. Organization:%0D%0A%0D%0A%20%20%20%203. Contact Info:%0D%0A%0D%0A%20%20%20%204. Purpose:%0D%0A%0D%0AUpon receipt of these details, we will respond to you promptly.%0D%0A%0D%0ABest Regards,%0D%0A%0D%0A[Your Name]">
                {' '}
                pr@duetapp.net
              </a>
            </div>
            <div className={styles.mail}>
              For Legal/Law Enforcement:
              <a href="mailto:legal@duetapp.net?subject=Duet Legal Inquiry&body=Dear Duet Team,%0D%0A%0D%0AI am writing to inquire about a legal matter. Here are the details:%0D%0A%0D%0A%20%20%20%201. Name:%0D%0A%0D%0A%20%20%20%202. Organization:%0D%0A%0D%0A%20%20%20%203. Contact Info:%0D%0A%0D%0A%20%20%20%204. Purpose:%0D%0A%0D%0AUpon receipt of these details, we will respond to you promptly.%0D%0A%0D%0ABest Regards,%0D%0A%0D%0A[Your Name]">
                {' '}
                legal@duetapp.net
              </a>
            </div>
          </div>
        </div>
      </RootLayout>
    );
  }
};
